import React from 'react'
import { Button } from '@mui/material'
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material'

/**
 * Matches EduOKWeb .eduok-back-btn — white glass pill on content-header.
 */
const BackButton = ({ onClick, label = 'Back', sx }) => {
  const handleClick = (event) => {
    event.preventDefault()
    if (onClick) {
      onClick(event)
    } else {
      window.history.back()
    }
  }

  return (
    <Button
      type="button"
      size="small"
      className="page-back-button eduok-back-btn"
      startIcon={<ArrowBackIcon sx={{ fontSize: '11px !important' }} />}
      onClick={handleClick}
      aria-label="Back"
      sx={{
        ml: 'auto',
        mt: 0,
        minHeight: 28,
        height: 28,
        minWidth: 28,
        lineHeight: 1,
        backgroundColor: 'rgba(25, 25, 25, 0.06)',
        border: '2px solid rgba(25, 25, 25, 0.72)',
        color: '#191919',
        fontSize: '12px',
        fontWeight: 700,
        letterSpacing: '0.01em',
        borderRadius: '8px',
        textTransform: 'none',
        boxShadow: 'none',
        px: '12px',
        py: 0,
        flexShrink: 0,
        transition: 'background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease',
        '& .MuiButton-startIcon': {
          marginRight: '6px',
          marginLeft: 0,
        },
        '&:hover': {
          backgroundColor: 'rgba(25, 25, 25, 0.12)',
          borderColor: '#191919',
          boxShadow: '0 4px 10px rgba(15, 23, 42, 0.18)',
          transform: 'translateY(-1px)',
        },
        '&:active': {
          transform: 'translateY(0)',
          boxShadow: 'none',
        },
        '@media (max-width: 480px)': {
          px: 0,
          width: 28,
          minWidth: 28,
          '& .MuiButton-startIcon': { marginRight: 0 },
          '& .eduok-back-btn__label': { display: 'none' },
        },
        ...sx,
      }}
    >
      <span className="eduok-back-btn__label">{label}</span>
    </Button>
  )
}

export default BackButton
